import { createFileRoute } from '@tanstack/react-router';

import { AppsPage } from '../features/supply/apps/AppsPage';
import { supplyAppsRouteSearchSchema } from '../features/supply/apps/appsRouteSearch';

export const Route = createFileRoute('/supply/apps/')({
  validateSearch: supplyAppsRouteSearchSchema,
  component: AppsPage,
});
